import React from 'react';
import dayjs from 'dayjs';
import {Layout, Text} from '@di-nxt/components';

type Props = {
  date: Date;
  disabled: boolean;
};

export const CalendarDateHeaderDay: React.FC<Props> = ({date, disabled}) => {
  return (
    <Layout
      height={28}
      horizontal
      flex
      left={-8}
      align="center"
      justify={'flex-start'}
      paddingVertical="10">
      <Text
        textColor={disabled ? 'content_mono_disabled' : undefined}
        align={'left'}
        variant="inline_12_default">
        {dayjs(date).format('HH')}
      </Text>
    </Layout>
  );
};
